"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */
var material_1 = require("@mui/material");
var LogoSection_1 = __importDefault(require("containers/AssistedOnboarding/LogoSection"));
var NotFoundHeader_1 = __importDefault(require("./styles/NotFoundHeader"));
var ThankYou = function () { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", width: "100%", height: "100%", flexGrow: 1, alignItems: "center", margin: "0 auto", position: "relative", justifyContent: { xs: 'center', md: 'center' }, flexDirection: { xs: 'column', md: 'row' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ position: "absolute", left: 0, top: 0 }, { children: (0, jsx_runtime_1.jsx)(LogoSection_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 3, display: "flex", flexDirection: "column", alignItems: { xs: 'center', md: 'flex-start' } }, { children: (0, jsx_runtime_1.jsx)(NotFoundHeader_1.default, { children: "Thank you!" }) }))] }))); };
exports.default = ThankYou;
